const topics = [

    {
      title: "Settled",
      slug: "settled",
      standardNumber: "1.2",
      description: "Let’s learn about Jamestown, the first permanent English settlement in America in 1607. Watch the video, sing the Jamestown song, then play the game to see what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsettled2022.mp4?alt=media&token=ccafb686-6eab-4cfe-b145-0fd1c3cf81b8",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsettled2025song.mp3?alt=media&token=c0f9efb7-febe-47bd-b658-311e40b076ad",
      lyrics: ["(Chorus)",
"In 1607, the English settled in Jamestown.",
"In 1607, the English settled in Jamestown.",
"Why bring colonies to America?",
"To increase the wealth and power.",
"Why bring colonies to America?",
"To find silver and gold.",
"Why bring colonies to America?",
"To open up new markets for trade.",
"Why bring colonies to America?",
"To get raw materials.",

"(Verse)",
"The Virginia Company of London’s stockholders,",
"Paid for the settlement.",
"They settled on a peninsula, surrounded on three sides by the James River.",
"The area was good for trade.",
"From the Spanish, they thought they were safe.",
"From the Spanish, they thought they were safe.",
"Their ships could come in to dock.",
"They thought their water supply was good.",

"(Chorus)",
"In 1607, the English settled in Jamestown.",
"In 1607, the English settled in Jamestown.",
"Why bring colonies to America?",
"To increase the wealth and power.",
"Why bring colonies to America?",
"To find silver and gold.",
"Why bring colonies to America?",
"To open up new markets for trade.",
"Why bring colonies to America?",
"To get raw materials.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Founders",
      slug: "founders",
      standardNumber: "1.2",
      description: "Let’s meet some important leaders like George Washington, Thomas Jefferson, and Abraham Lincoln who helped shape our country. Watch the video, sing the founders song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ffounders2025video.mp4?alt=media&token=885d2cec-ff29-403c-bb7d-4c06f1877f42",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffounders2025song.mp3?alt=media&token=6bc11234-83e1-4818-988c-43535c6396d2",
      lyrics: ["(chorus)",
"Can you name some founders of the United States?,",
"Yes, yes.,",
"Can you name some founders of the United States?,",
"Yes, yes.,",

"(verse)",
"George Washington is called the father of our country.,",
"He was the 1st President of the United States.,",
"Thomas Jefferson wrote the Virginia Statue for Religious Freedom,,",
"for Religious Freedom.,",
"Thomas Jefferson was one of the founders of the",
"Declaration of Independence.,",
"Abraham Lincoln was the 16th president,,",
"he helped to end slavery.,",
"Abraham Lincoln was the 16th president,,",
"he helped to end slavery.,",

"(chorus)",
"Can you name some founders of the United States?,",
"Yes, yes.,",
"Can you name some founders of the United States?,",
"Yes, yes.,",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Settlers & Natives",
      slug: "settlersandnatives",
      standardNumber: "1.3",
      description: "Let’s learn how the Jamestown settlers and the Native Americans worked together through trade and survival skills. Watch the video, sing the Jamestown and Natives song, then play the game to test what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsettlersandnatives2025video.mp4?alt=media&token=940c1422-225d-40ff-a542-7ccacad270ab",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsettlersandnatives2025song.mp3?alt=media&token=a5db0c94-fba2-4bf5-b284-0bac1d75da7b",
      lyrics: ["(chorus)",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",

"(verse)",
"The settlers learned survival skills",
"from Chief Powhatan.",
"The settlers used Pocahontas as a contact,",
"daughter of Chief Powhatan.",
"The settlers learned how to plant corn",
"from the Natives.",
"The settlers learned how to plant corn",
"from the Natives.",
"The Natives traded with the English for tools and copper.",
"The Natives traded with the English for tools and copper.",
"Trade with the Natives began with Captain John Smith.",

"(chorus)",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",
"Jamestown settlers and the Natives.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Christopher Newport",
      slug: "christophernewport",
      standardNumber: "1.3",
      description: "Let’s learn about Christopher Newport, the English sea captain who helped bring people and supplies to Jamestown. Watch the video, sing the Christopher Newport song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fchristophernewport2025video.mp4?alt=media&token=ceffe383-e97f-4e45-9f0a-89d6a179fcc5",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fchristophernewport2025song.mp3?alt=media&token=46a7bec8-0cd3-4eab-a83d-18d68ecf6f10",
      lyrics: ["(chorus)",
"British Captain on the sea,",
"was a founder of Jamestown colony.",
"British Captain on the sea,",
"was a founder of Jamestown colony.",

"(verse)",
"Christopher Newport was an English explorer.",
"Christopher Newport took his ship across water.",
"Christopher Newport went from England to Jamestown.",
"He took people and supplies to Jamestown then back around.",

"(chorus)",
"British Captain on the sea,",
"was a founder of Jamestown colony.",
"British Captain on the sea,",
"was a founder of Jamestown colony.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Contributions",
      slug: "contributions",
      standardNumber: "1.3",
      description: "Let’s learn about important Virginians like Arthur Ashe, Maggie Walker, L. Douglas Wilder, and Oliver Hill who made big contributions in sports, business, politics, and civil rights. Watch the video, sing the Virginia leaders song, then play the game to test what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcontributions2025video.mp4?alt=media&token=8b57a668-ba03-40b3-b0e6-dbd5d42d8943",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcontributions2025song.mp3?alt=media&token=154ecdca-e8a1-481f-b187-eec0aaf4d74a",
      lyrics: ["(chorus)",
"In the 20th and 21st century,",
"who made social contributions to Virginia?",
"In the 20th and 21st century,",
"who made political contributions to Virginia?",
"In the 20th and 21st century,",
"who made economic contributions to Virginia?",

"(verse 1)",
"Author Ashe wrote about social change.",
"Author Ashe spoke about social change.",
"He was the first African American to win",
"a major championship in Men's Singles tennis.",
"Maggie Walker was the first African American woman",
"to become bank president in the U.S.",
"Maggie Walker was the first African American woman",
"to become Bank President in the U.S.",

"(chorus)",
"In the 20th and 21st century,",
"who made social contributions to Virginia?",
"In the 20th and 21st century,",
"who made political contributions to Virginia?",

"(verse 2)",
"L. Douglas Wilder was the first African American",
"elected as a state governor in Virginia.",
"Oliver Hill, a lawyer, a Civil Rights leader,",
"he worked for equal rights of African Americans.",
"Oliver Hill, a lawyer, a Civil Rights leader,",
"he helped with Brown V. Board of Education.",

"(chorus)",
"In the 20th and 21st century,",
"who made social contributions to Virginia?",
"In the 20th and 21st century,",
"who made political contributions to Virginia?",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Abraham Lincoln",
      slug: "abrahamlincoln",
      standardNumber: "1.3",
      description: "Let’s learn about Abraham Lincoln, the 16th president who helped end slavery and keep our country together during the Civil War. Watch the video, sing the Abraham Lincoln song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fabrahamlincoln2025video.mp4?alt=media&token=37424f34-5f48-4d9f-af6a-526d9b14872d",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fabrahamlincoln.mp3?alt=media&token=bae458d6-0b42-4392-aeb4-3d24c7adc90d",
      lyrics: ["(chorus)",
"Abraham Lincoln was the 16th, President.",
"Abraham Lincoln, a United States resident.",
"Abraham Lincoln, Abraham, Abraham,",
"Abraham Lincoln, Abraham, Abraham.",

"(verse 1)",
"Abraham Lincoln, a President of mine,",
"was born February 12, 1809.",
"Abraham Lincoln was born in Kentucky.",
"Abraham Lincoln really loved to read.",
"On his father's farm he would chop down trees",
"and plowed the land.",
"He helped his family.",
"When Abraham grew up, he worked in a store.",
"Abraham became a mailman, then he became a lawyer.",

"(chorus)",
"Abraham Lincoln was the 16th, President.",
"Abraham Lincoln, a United States resident.",
"Abraham Lincoln, Abraham, Abraham,",
"Abraham Lincoln, Abraham, Abraham.",

"(verse 2)",
"Abraham Lincoln made a life choice",
"when he married Mary Todd and they had four boys.",
"Then Abraham Lincoln, a United States resident",
"became the 16th president.",
"During Abraham’s presidency",
"the Civil War began, a very long time for our country.",
"Abraham Lincoln was a great leader.",
"He freed the slaves and held our country together.",

"(chorus)",
"Abraham Lincoln was the 16th, President.",
"Abraham Lincoln, a United States resident.",
"Abraham Lincoln, Abraham, Abraham,",
"Abraham Lincoln, Abraham, Abraham.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Benjamin Franklin",
      slug: "benjaminfranklin",
      standardNumber: "1.3",
      description: "Let’s learn about Benjamin Franklin, a leader, inventor, and writer who helped shape America and even proved that lightning is electricity. Watch the video, sing the Benjamin Franklin song, then play the game to test what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fbenjaminfranklin2025video.mp4?alt=media&token=d3b4d87c-b523-4e1f-89f8-3a030ae0ad62",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fbenjaminfranklin2025song.mp3?alt=media&token=931e278a-40ea-405d-acae-a99e4cc1951d",
      lyrics: ["(Chorus)",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",

"(Verse 1)",
"Benjamin Franklin invented bifocals.",
"Bifocals or glasses, if you don't know.",
"Benjamin wanted to prove that lightning is electricity.",
"So, Benjamin conducted a famous kite experiment with a key.",
"Benjamin helped to start America's first library.",
"He helped to put streetlights and paved roads in Philadelphia, the city.",

"(Chorus)",
"Benjamin Franklin.",
"Benjamin Franklin.",

"(Verse 2)",
"The Declaration of Independence was partly written by Benjamin.",
"Benjamin also signed the United States Constitution.",
"Benjamin Franklin was a scientist and an inventor.",
"Benjamin Franklin was a writer and a leader.",
"Benjamin Franklin’s face is on the hundred bill I spent.",
"What Benjamin Franklin was not? He was not President.",

"(Chorus)",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "People",
      slug: "people",
      standardNumber: "1.3",
      description: "Let’s learn about George Washington, Abraham Lincoln, and Betsy Ross, important people who helped shape America’s history. Watch the video, sing the People from Our Past song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpeople2025video.mp4?alt=media&token=957a3212-a73d-4f78-a3b1-dc6a4079acd3",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpeople2025song.mp3?alt=media&token=8359150c-fa84-4aa0-8283-e4a3fe001ef4",
      lyrics: ["(chorus)",
"People from our past.",
"These are people from our past.",

"(verse)",
"George Washington was our 1st President.",
"George Washington was our 1st President.",
"He was called the Father of our Country.",
"He was called the Father of our Country.",
"Abraham Lincoln was our 16th President.,",
"Abraham Lincoln was our 16th President.",
"He was called Honest Abe.",
"He was called Honest Abe.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",

"(chorus)",
"People from our past.",
"These are people from our past.",
"These are people from our past.",

"(verse)",
"George Washington was our 1st President.",
"George Washington was our 1st President.",
"He was called the Father of our Country.",
"He was called the Father of our Country.",
"Abraham Lincoln was our 16th President.",
"Abraham Lincoln was our 16th President.",
"He was called Honest Abe.",
"He was called Honest Abe.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",

"(chorus)",
"People from our past.",
"These are people from our past.",
"These are people from our past.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Holidays",
      slug: "holidays",
      standardNumber: "1.4",
      description: "Let’s learn about important American holidays like Martin Luther King Jr. Day, Presidents Day, Memorial Day, Independence Day, and Veterans Day. Watch the video, sing the holidays song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fholidays3rdgradeva.mp4?alt=media&token=9b8c3d1d-efbb-476b-b040-86df66f25236",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fholidays3rdgrade2022.mp3?alt=media&token=b1ef8a09-e63d-4a65-817e-eb1bdfccc528",
      lyrics: ["(Verse)",
"One day in January we remember",
"a man who worked hard so all people would be treated equal.",
"It’s a holiday,",
"Martin Luther King Jr. Day.",
"It’s a holiday,",
"Martin Luther King Jr. Day.",

"One day in February is for the greats.",
"We honor all presidents of The United States.",
"It’s a holiday,",
"Presidents Day.",
"It’s a holiday,",
"Presidents Day.",

"One day in May we remember",
"Americans who died during war while serving our country.",
"It’s a holiday,",
"Memorial Day.",
"It’s a holiday,",
"Memorial Day.",

"On the Fourth of July we celebrate",
"becoming a new country, America’s birthday.",
"It’s a holiday,",
"Independence Day, The 4th of July.",
"It’s a holiday,",
"Independence Day, The 4th of July.",

"One day in November we remember",
"Americans who served in the military.",
"It’s a holiday,",
"Veterans Day.",
"It’s a holiday,",
"Veterans Day.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Dr. Martin Luther King Jr.",
      slug: "drmartinlutherkingjr",
      standardNumber: "1.4",
      description: "Let’s learn about Dr. Martin Luther King Jr., a leader who fought for equal rights and gave the famous ‘I Have a Dream’ speech. Watch the video, sing the Martin Luther King Jr. song, then play the game to test what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdrmartinlutherkingjr2025video.mp4?alt=media&token=df730bc0-7199-4a8b-bf51-509505e2a40c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdrmartinlutherking2025song.mp3?alt=media&token=cfe6a225-2726-4001-8161-8d5dcff1c13d",
      lyrics: ["(Chorus)",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",

"(Verse)",
"Dr. Martin Luther King Jr. was an African American man.",
"His father was a minister and Martin was a good student.",
"He was born in 1929 on January 15th.",
"He began college when he was only 15.",
"Dr. Martin Luther King Jr. became a minister just like his dad.",
"He worked hard to change laws that were unfair.",
"Dr. Martin Luther King Jr. gave his famous speech, “I Have a Dream.”",
"He was killed one day because he fought for what he believed.",

"(Chorus)",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "My Map",
      slug: "mymap",
      standardNumber: "1.5",
      description: "Let’s learn the parts of a map, like the title, legend, and compass rose that show directions. Watch the video, sing the map song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmymap2025video.mp4?alt=media&token=3291496b-9cbc-4a61-8810-acb3cacf3f99",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmymap2025song.mp3?alt=media&token=982b6c7f-d3c6-466b-9c7b-e77a491faf35",
      lyrics: ["(verse)",
"When we make a map,",
"when we make a map,",
"we must include the title.",
"That’s the name or kind of map.",
"When we make a map,",
"when we make a map,",
"we must include the title.",
"That’s the name or kind of map.",
"When we make a map,",
"when we make a map,",
"we must include the legend.",
"Symbols and what each one stands for.",
"When we make a map,",
"when we make a map,",
"we must include the legend.",
"Symbols and what each one stands for.",
"When we make a map",
"we must include a compass rose.",
"It shows directions,",
"North, south, east, and west.",
"When we make a map",
"we must include a compass rose.",
"It shows directions,",
"North, south, east, and west.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Capital of VA",
      slug: "capitalofva",
      standardNumber: "1.5",
      description: "Let’s learn about our country’s capital, Washington D.C., and our state’s capital, Richmond, Virginia. Watch the video, sing the capitals song, then play the game to test what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcapitalofva.mp4?alt=media&token=af6346fc-765b-4373-967b-5f27085c2b88",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcapitalofva2025song.mp3?alt=media&token=656b61a8-cebb-40fb-a1ed-1da4664b43eb",
      lyrics: ["(Verse)",
"We live in the United States.",
"We live in the United States.",
"The capital of the United States",
"Is Washington, D.C.",

"We live in the United States.",
"We live in the United States.",
"The capital of the United States",
"Is Washington, D.C.",

"(Verse)",
"We live in Virginia.",
"We live in Virginia.",
"The capital of Virginia",
"Is Richmond, Richmond, Richmond, Richmond.",

"We live in Virginia.",
"We live in Virginia.",
"The capital of Virginia",
"Is Richmond, Richmond, Richmond, Richmond.",

"We live in Virginia.",
"We live in Virginia.",
"The capital of Virginia",
"Is Richmond, Richmond, Richmond, Richmond.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Seasons",
      slug: "seasons",
      standardNumber: "1.6",
      description: "Let’s learn about the four seasons—spring, summer, fall, and winter—and how they happen because Earth’s axis is tilted. Watch the video, sing the seasons song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fseasons2025video.mp4?alt=media&token=dd682414-ff8a-4acb-8877-5a488cd7a912",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fseasons2025song.mp3?alt=media&token=04a34ce0-7b3c-4e70-8564-cc5ac75c2bfc",
      lyrics: ["(chorus)",
"There is something we have to get clear now,",
"there are four seasons in every year now.",
"Do you know the reasons for the seasons? Check this,",
"seasons come because of the tilt of the Earth's axis.",

"(verse)",
"We spring ahead in the Spring, then comes the Summer.",
"Watch the leaves change color, we fall back in Autumn.",
"Then comes the Winter, which is the coldest season.",
"The Earth spins on an axis that is tilted, is the reason why this happens.",

"(chorus)",
"There is something we have to get clear now,",
"there are four seasons in every year now.",
"Do you know the reasons for the seasons? Check this,",
"seasons come because of the tilt of the Earth's axis.",

"(bridge)",
"Summer, Winter, Spring, Fall.",
"Summer, Winter, Spring, Fall.",
"Summer, Winter, Spring, Fall.",
"Summer, Winter, Spring, Fall.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Producer",
      slug: "producer",
      standardNumber: "1.7/1.9",
      description: "Let’s learn about producers who make goods and services, and consumers who use them. Watch the video, sing the producers and consumers song, then play the game to test what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fproducer2025video.mp4?alt=media&token=927f12da-8625-49c4-9b45-c6dc89b4ae06",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fproducer2025song.mp3?alt=media&token=9907f02f-44ae-4bdc-a63d-241c0140ca0d",
      lyrics: ["(verse)",
"I make goods and I provide services.",
"I make goods and I provide services.",
"That makes me a producer,",
"that makes me a producer.",
"I make goods and I provide services.",
"I make goods and I provide services.",
"That makes me a producer,",
"that makes me a producer.",
"I use the goods and services that are made by the producers.",
"That makes me a consumer.",
"I use the goods and services that are made by the producers.",
"That makes me a consumer.",
"When resources are scarce, that means limited resources,",
"limited resources.",
"When resources are scarce, that means limited resources,",
"limited resources.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Wants & Choices",
      slug: "wantsandchoices",
      standardNumber: "1.8",
      description: "Let’s learn about wants, the things we would like to have, and choices, the decisions we make when we can’t have everything. Watch the video, sing the wants and choices song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwantsandchoices2025video.mp4?alt=media&token=46126733-76e4-468d-8dfd-2b3605f22776",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwantsandchoices2025song.mp3?alt=media&token=0cab7c9d-c510-4459-8e07-bd57a18920e6",
      lyrics: ["(Verse)",
"Things that we would like to have are called wants.",
"That’s what we want.",
"We can choose between two or more things, that’s a choice.",
"We have a choice.",
"Some choices that we make are made because we can’t have everything we want,",
"we want.",

"Things that we would like to have are called wants.",
"That’s what we want.",
"We can choose between two or more things, that’s a choice.",
"We have a choice.",
"Some choices that we make are made because we can’t have everything we want,",
"we want.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Resposnible Citizen",
      slug: "responsiblecitizen",
      standardNumber: "1.10",
      description: "Let’s learn what it means to be a responsible American citizen, like following laws, paying taxes, and helping our community. Watch the video, sing the responsible citizens song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fresponsiblecitizen2025video.mp4?alt=media&token=c686e9e2-9c58-4d29-88ac-75835950a857",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fresponsiblecitizen2025song.mp3?alt=media&token=4fe0f14e-695b-4155-8ad4-696cbe08b452",
      lyrics: ["(Chorus)",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",

"(Verse)",
"Responsible citizens have civic duties.",
"Responsible citizens obey laws.",
"Responsible citizens serve on a jury,",
"Or as a witness, if they are called.",
"Responsible citizens have civic duties.",
"Responsible citizens pay their taxes.",
"Responsible citizens serve in the armed forces,",
"If they are called.",

"(Chorus)",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Pledge",
      slug: "pledge",
      standardNumber: "1.11",
      description: "Let’s learn about the President of the United States and the American Flag, our nation’s symbol of freedom. Watch the video, sing the flag and pledge song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpledge.mp4?alt=media&token=c4877dc3-d775-42d5-b8e0-960352101e3f",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpledge.mp3?alt=media&token=c712b543-9b61-437e-944c-02c04b85a3eb",
      lyrics: ["(verse)",
"The leader of the United States",
"is the President, is the President.",
"The leader of the United States",
"is the President, is the President.",

"(verse)",
"The American Flag is red, white and blue,",
"with white stars, red and white stripes.",
"The American Flag is red, white and blue,",
"with white stars, red and white stripes.",

"(verse)",
"When we pledge to the American Flag",
"we recite the Pledge of Allegiance.",

"(verse)",
"I pledge allegiance to the Flag of the United States of America,",
"and to the Republic for which it stands, one Nation under God, indivisible, with liberty and justice for all.",

"(verse)",
"When we pledge to the American Flag",
"we recite the Pledge of Allegiance.",
"When we pledge to the American Flag",
"we recite the Pledge of Allegiance.",

"© Smart Board Learning, LLC. All rights reserved.",
],
    },
    {
      title: "VA State Bird",
      slug: "vastatebird",
      standardNumber: "1.12",
      description: "Let’s learn about the Cardinal, Virginia’s state bird, known for its bright red color and beautiful whistling song. Watch the video, sing the state bird song, then play the game to test what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fvastatebird.mp4?alt=media&token=d45ad8d2-14e9-4137-90ee-e33ecbf44b57",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FeMastered_Virginia%20State%20Bird%20-%20Final.mp3?alt=media&token=ab2abcbb-e9b7-413d-90cf-bbb8b7e945e7",
      lyrics: ["(verse)",
"The State bird is the Cardinal.",
"The State bird is the Cardinal.",
"Named after the Catholic cardinals who dressed in bright red robes.",

"The male Cardinal has a red beak.",
"The male Cardinal has a red beak.",
"The male Cardinal has a red body, red head, red tail and red wings.",

"The female Cardinal is brown.",
"The female Cardinal is brown.",
"They have red beaks and red wings,",
"that you can see when they fly around.",

"The Cardinal is a songbird.",
"The Cardinal is a songbird.",
"The Cardinal has a loud, whistling song that can be heard.",

"The Cardinal is red and pretty.",
"The Cardinal is red and pretty.",
"The Cardinal became the state bird of Virginia in 1950.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "VA State Flag",
      slug: "vastateflag",
      standardNumber: "1.12",
      description: "Let’s learn about the Virginia State Flag, which shows the state seal with Virtus, the goddess of bravery, on a dark blue background. Watch the video, sing the state flag song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fvastateflag.mp4?alt=media&token=9ce5daff-399c-482e-9a20-99083b84fb0c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FState%20Flag%20Virginia%20-%20Final%20New.mp3?alt=media&token=c4a71d75-803f-442c-8f42-aa3dcb02f4b6",
      lyrics: ["(chorus)",
"The Virginia State Flag.",
"The Virginia State Flag.",

"(verse)",
"The State Flag of Virginia has a dark blue back field.",
"The image on the flag is the seal, the Virginia State Seal.",

"On the seal, you will see Virtus, the Roman Goddess.",
"She’s the goddess of bravery and military strength.",

"The Virginia State flag was adopted in 1861.",
"The Virginia State flag was adopted in 1861.",

"(chorus)",
"The Virginia State Flag.",
"The Virginia State Flag.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "VA State Flower",
      slug: "vastateflower",
      standardNumber: "1.12",
      description: "Let’s learn about Virginia’s state flower, the Dogwood, with its beautiful white or pink blooms in spring and colorful red and orange leaves in fall. Watch the video, sing the state flower song, then play the game to test what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fvastateflower.mp4?alt=media&token=4865e598-8f15-40fd-a9b4-1609a0fc0e61",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FeMastered_Virginia%20State%20Flower%20-%20Final.mp3?alt=media&token=23e6dc14-4e53-4b36-b84b-81c50f867647",
      lyrics: ["(chorus)",
"The Virginia state flower is good.",
"The Virginia state flower is the Dogwood.",
"With four white petals surrounding green clusters in the middle.",
"During the fall, their colors change like Skittles.",

"The Virginia state flower is good.",
"The Virginia state flower is the Dogwood.",
"With four white petals surrounding green clusters in the middle.",
"During the fall, their colors change like Skittles.",

"(verse)",
"State flower is good.",
"State flower is Dogwood.",
"The outside’s white, center green.",
"State flower since 1918.",
"Dogwood blooms in spring,",
"pretty white, sometimes pink.",
"In the fall, the leaves change",
"beautiful colors, red and orange.",
"Then the leaves fall in winter, the leaves fall in winter,",
"the leaves fall in winter, the leaves fall in winter.",
"Dogwood blooms in spring,",
"pretty white, sometimes pink.",
"In the fall, the leaves change",
"beautiful colors, red and orange.",

"(chorus)",
"The Virginia state flower is good.",
"The Virginia state flower is the Dogwood.",
"With four white petals surrounding green clusters in the middle.",
"During the fall, their colors change like Skittles.",

"The Virginia state flower is good.",
"The Virginia state flower is the Dogwood.",
"With four white petals surrounding green clusters in the middle.",
"During the fall, their colors change like Skittles.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "Capitol Building",
      slug: "capitolbuilding",
      standardNumber: "1.12",
      description: "Let’s learn about the U.S. Capitol, where Congress meets to make and pass laws, with the Statue of Freedom standing tall on top. Watch the video, sing the Capitol Building song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fuscapitolbuilding.mp4?alt=media&token=13c614d2-d018-43aa-9dd3-5ad1c7044c10",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FThe%20Capitol%20Building%20-%20Final.mp3?alt=media&token=99e32872-1d38-49c2-ac5c-e6a68059e9a7",
      lyrics: ["(chorus)",
"This is our Capitol Building.",
"This is our Capitol Building.",
"This is our Capitol Building.",
"This is our Capitol Building.",

"(verse)",
"The Capitol building is where the US Congress meet.",
"100 Constitutional Ave. Northwest, Washington DC.",
"In the Capitol Building we have senators and the house of representatives.",
"Each representative represents the state that they live in.",
"The Capitol Building is over 200 years old, of course.",
"Congress meets at the Capitol Building to make and pass laws.",
"The statue on top of the dome is not misleading.",
"It represents the United States, and it’s called the Statue of Freedom.",

"(chorus)",
"This is our Capitol Building.",
"This is our Capitol Building.",
"This is our Capitol Building.",
"This is our Capitol Building.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "American Flag",
      slug: "americanflag",
      standardNumber: "1.12",
      description: "Let’s learn about the American Flag with its fifty stars for the states and thirteen stripes for the original colonies. Watch the video, sing the flag song, then play the game to test what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Famericanflag2025video.mp4?alt=media&token=756a44ba-d6af-41b4-bd71-bc2db4f1c554",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Famericanflag2025song.mp3?alt=media&token=1331c218-f3c0-4069-bee1-01085c9823df",
      lyrics: ["(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"(Verse 1)",
"With stars and stripes, here we stand.",
"A flag waves proudly, across the land.",
"Through the breeze we see freedom dance.",
"Come one, come all, come take a chance.",
"With fifty stars, we see them blooming,",
"As the 50 States of the Union.",
"Thirteen stripes will always follow me,",
"And represent the thirteen original colonies.",

"(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"(Verse 2)",
"Patriotism is in everyone’s heart.",
"A love for our country, a love with a spark.",
"In its colors, find joy and pride.",
"The America's spirit will forever fly.",
"With fifty stars, we see them blooming,",
"As the 50 States of the Union.",
"Thirteen stripes will always follow me,",
"And represent the thirteen original colonies.",

"(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
    {
      title: "VA United",
      slug: "vaunited",
      standardNumber: "1.13",
      description: "Let’s learn how the people of Virginia work together by voting, volunteering, and helping their communities. Watch the video, sing the Virginians song, then play the game to practice what you know!",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fvaunited2025video.mp4?alt=media&token=5687815e-0c5a-4aa3-9573-e603b4d5794c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fvaunited2025song.mp3?alt=media&token=4f534d13-dc31-4abb-a545-15440b28d24f",
      lyrics: ["(verse)",
"We, the people of Virginia, are united.",
"We are Americans, we are Americans.",
"We, the people of Virginia, are united.",
"We vote in elections, vote in elections.",
"We, the people of Virginia, are united.",
"Elect local governments, elect local governments to help make a better place to work and live.",
"We, the people of Virginia, are united.",
"Come from different places, many different races.",
"We, the people of Virginia, are united.",
"Come from different places, many different races.",
"We, the people of Virginia, are united.",
"By volunteering and helping our community.",
"We, the people of Virginia, are united.",
"We are Americans, we are Americans.",

"© Smart Board Learning, LLC. All rights reserved.",],
    },
 
];
export default topics;